import script from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingToolModeControls.vue?vue&type=script&setup=true&lang=js"

import "./DrawingToolModeControls.vue?vue&type=style&index=0&id=7f294ed6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f294ed6"]])

export default __exports__